import { useFlags } from 'config/useFlagsContext'
import { useRiscosQuery } from 'graphql/hooks.generated'
import { GrupoRisco, Risco } from 'graphql/types.generated'
import { AlertaSuporteDecisaoClinica } from 'hooks/sdc/model-sdc'
import { useMemo } from 'react'
import { emptyArrayOf } from 'util/array'

import { ProntuarioCard } from '../../ProntuarioCard'
import { RastreamentosCard } from './RastreamentosCard'

interface RastreamentosSectionProps {
  prontuarioId: ID
  alertasSdc?: AlertaSuporteDecisaoClinica[]
}

export function RastreamentosSection(props: Readonly<RastreamentosSectionProps>) {
  const { prontuarioId, alertasSdc = emptyArrayOf() } = props

  const { PILOTO_RISCOS_SDC_ENABLED } = useFlags()

  const { data, loading: loadingRiscos } = useRiscosQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      input: {
        prontuarioId,
        ativo: true,
      },
    },
    skip: !prontuarioId || !PILOTO_RISCOS_SDC_ENABLED,
  })

  const riscos: ReadonlyArray<Risco> = useMemo(() => {
    const riscosPersistidos = data?.riscos ?? emptyArrayOf<Risco>()
    const riscosAlertas = alertasSdc.flatMap((alerta) => alerta.riscos).filterNotNull()

    const porGrupo = [...riscosPersistidos, ...riscosAlertas].reduce((map, risco) => {
      if (risco.grupo) map.set(risco.grupo, risco)
      return map
    }, new Map<GrupoRisco, Risco>())

    return Array.from(porGrupo.values())
  }, [data, alertasSdc])
  const canRender = riscos.length > 0

  const showTooltip = !canRender && !loadingRiscos

  return (
    <ProntuarioCard
      title='Rastreamentos'
      tooltip={showTooltip ? 'Nenhum rastreamento registrado' : undefined}
      dataTestId='ProntuarioCard.rastreamento'
    >
      <RastreamentosCard
        canRender={canRender}
        loading={loadingRiscos}
        riscos={riscos}
        dataTestId='ProntuarioCard.rastreamento.card'
      />
    </ProntuarioCard>
  )
}
